// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IRoute } from '../';
import ProductSafetyForm from './ProductSafetyForm';

const productSafetyFormRoutes: IRoute[] = [
    {
        crumbText: 'Product Safety Form',
        component: ProductSafetyForm,
        exact: true,
        path: '/productSafetyForm',
        public: true,
    },
];

export default productSafetyFormRoutes;
